import { render } from "./ModalResizable.vue?vue&type=template&id=3d4cbfb5&ts=true"
import script from "./ModalResizable.vue?vue&type=script&lang=ts"
export * from "./ModalResizable.vue?vue&type=script&lang=ts"

import "./ModalResizable.vue?vue&type=style&index=0&id=3d4cbfb5&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__